import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getWallet
}

function getWallet(userId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/wallets`)
           .set('access', Storage.getItem('access'))
           .query({userId})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}